/* eslint-disable */
// @ts-ignore
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";
import type { SearchResponseModel } from "~/feature/Search/generated-types";
import type { SearchFilterModel } from "~/feature/Search/generated-types";
import type { PublicationSearchFilterModel } from "~/feature/Search/generated-types";

export const searchContentServiceMeta: Meta<typeof searchContentService> = {
	allSearch: ["GET", "/api/v1/search/content/all/:context"],
	mediaSearch: ["GET", "/api/v1/search/content/media/:context"],
	articleSearch: ["GET", "/api/v1/search/content/article/:context"],
	magazineSearch: ["GET", "/api/v1/search/content/magazine/:context"],
	publicationSearch: ["GET", "/api/v1/search/content/publication/:context"],
};

// FeatureJss.Search.WebApi.SearchContentApiController
export const searchContentService = {
	async allSearch(context: /* Guid */ string, queryStrings: SearchFilterModel, headers?: Record<string, any>) {
		return await http.fetch<SearchResponseModel, undefined>(searchContentServiceMeta.allSearch, { params: { context }, queryStrings, headers });
	},
	async mediaSearch(context: /* Guid */ string, queryStrings: SearchFilterModel, headers?: Record<string, any>) {
		return await http.fetch<SearchResponseModel, undefined>(searchContentServiceMeta.mediaSearch, { params: { context }, queryStrings, headers });
	},
	async articleSearch(context: /* Guid */ string, queryStrings: SearchFilterModel, headers?: Record<string, any>) {
		return await http.fetch<SearchResponseModel, undefined>(searchContentServiceMeta.articleSearch, { params: { context }, queryStrings, headers });
	},
	async magazineSearch(context: /* Guid */ string, queryStrings: SearchFilterModel, headers?: Record<string, any>) {
		return await http.fetch<SearchResponseModel, undefined>(searchContentServiceMeta.magazineSearch, { params: { context }, queryStrings, headers });
	},
	async publicationSearch(context: /* Guid */ string, queryStrings: PublicationSearchFilterModel, headers?: Record<string, any>) {
		return await http.fetch<SearchResponseModel, undefined>(searchContentServiceMeta.publicationSearch, { params: { context }, queryStrings, headers });
	},
};
